export default __webpack_public_path__ + "static/media/faq1.788fe256.svg";